import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearch } from "../../context/SearchContext";
import { StripFabric } from "./StripFabric";
import { getFabricFileFetch } from "../../features/action/fetchFabric";
import { ChartFabric } from "./ChartFabric";

const Fabrik = () => {
  const { fabric } = useSelector((state) => state.fabric);
  const { searchQuery, setSearchData, searchData } = useSearch();
  const [openTables, setOpenTables] = useState({});
  const dispatch = useDispatch();

  const toggleTable = (chart) => {
    setOpenTables((prev) => ({
      ...prev,
      [chart]: !prev[chart],
    }));
  };

  useEffect(() => {
    dispatch(getFabricFileFetch());
  }, [dispatch]);

  return (
    <div className="flex m-auto  w-[100%]">
      <div className="flex flex-col  w-[100%] mx-auto my-1">
        <div className="flex flex-row  w-[99%] my-6 text-center text-[#9E9E9E] text-[1vw] mx-auto ">
         
        </div>
        {fabric &&
          fabric.map((i) => (
            <React.Fragment key={i._id}>
              <StripFabric i={i} onToggle={() => toggleTable(i._id)} />
              {openTables[i._id] && i.chart && <ChartFabric chart={i.chart} />}
            </React.Fragment>
          ))}
      </div>
    </div>
  );
};

export default Fabrik;
